<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">
            <span> {{ $t("header.nav2") }}</span>
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="th2">{{ $t("acq.th") }}</div>
          <div class="txt">{{ $t("acq.tit") }}<br />{{ $t("acq.tit2") }}</div>
        </div>
      </div>

      <div id="section2">
        <div class="container">
          <div class="d-flex">
            <div class="content">
              <div class="th">{{ $t("acq.sec1.tit") }}</div>
              <div>
                <div class="d-flex align-items-center">
                  <div class="th2">1</div>
                  <div class="txt">
                    {{ $t("acq.sec1.p1") }}
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="th2">2</div>
                  <div class="txt">
                    {{ $t("acq.sec1.p2") }}
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="th2">3</div>
                  <div class="txt">
                    {{ $t("acq.sec1.p3") }}
                  </div>
                </div>
                <div>
                  <div class="th4">
                    {{ $t("acq.sec1.th4") }}
                  </div>
                  <img src="@/assets/acq-5.png" width="562px" />
                </div>
              </div>
            </div>
            <img src="@/assets/acq-2.png" width="450px" class="pic" />
          </div>
        </div>
      </div>

      <div id="section3">
        <div class="container">
          <div class="list d-flex">
            <div class="item" v-for="i in 4">
              <svgIcon className="icon" :iconName="`icon-acq${i}`"></svgIcon>
              <div>
                <div class="th2">{{ $t(`acq.sec2.t${i}`) }}</div>
                <div class="tips">
                  {{ $t(`acq.sec2.tips${i}`) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="section4">
        <div class="container">
          <div class="th">{{ $t("acq.sec3.tit") }}</div>
          <div class="box">
            <img src="@/assets/acq-3.png" alt="" />
            <div class="item t1">
              <div class="th2">{{ $t("acq.sec3.t1") }}</div>
              <div class="tips">
                {{ $t("acq.sec3.tips1") }}
              </div>
            </div>
            <div class="item t2">
              <div class="th2">{{ $t("acq.sec3.t2") }}</div>
              <div class="tips">
                {{ $t("acq.sec3.tips2") }}
              </div>
            </div>
            <div class="item t3">
              <div class="th2">{{ $t("acq.sec3.t3") }}</div>
              <div class="tips">{{ $t("acq.sec3.tips3") }}</div>
            </div>
            <div class="item t4">
              <div class="th2">{{ $t("acq.sec3.t4") }}</div>
              <div class="tips">
                {{ $t("acq.sec3.tips4") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="section5">
        <div class="container">
          <div class="box d-flex align-items-center">
            <div>
              <div class="th2">
                {{ $t("acq.sec4.tit") }}<br />{{ $t("acq.sec4.tit2") }}
              </div>
              <div class="tips">
                {{ $t("acq.sec4.tips") }}
              </div>
            </div>
            <img src="@/assets/acq-4.png" width="316px" height="100%" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import "@/assets/css/animate.css";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      activeId: "#section",
      channel: this.$route.query.channel,
      httpIp: "https://naps.zxszkj.com",
      carouselIndex: 0,
      partId: "1",
      addresssId: "a1",
      address: {
        a1: { x: 127, y: 535, name: "中国总部" },
        a2: { x: 162, y: 518, name: "香港" },
        a3: { x: 188, y: 323, name: "尼日利亚" },
        a4: { x: 213, y: 391, name: "坦桑尼亚" },
        a5: { x: 109, y: 428, name: "哈萨克斯坦" },
        a6: { x: 203, y: 518, name: "新加坡" },
      },
    };
  },
  mounted() {
    localStorage.setItem("channel", this.$route.query.channel);
  },
  methods: {
    toProduct() {
      this.$router.push("/product");
    },
    openAbout() {
      window.open(`${this.httpIp}/#/about`);
    },
    openLogin() {
      this.$router.push("/login");
    },

    changeCarousel(index) {
      console.log(index);
      this.carouselIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}
.container {
  padding: 0;
}
.subtitle {
  font-weight: 300;
  font-size: 64px;
  color: #000000;
  line-height: 78px;
  span {
    color: #1485ef;
  }
}
.tips {
  font-weight: 400;
  font-size: 18px;
  color: #9e9e9e;
  line-height: 27px;
}
.arrow-right {
  position: relative;
  top: 6.5px;
  width: 12px;
  height: 12px;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  transform: translate(0, -50%) rotate(-135deg);
}

#section1 {
  height: 203px;
  background-image: url(~@/assets/acq-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 11px;
    margin-bottom: 11px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
  .txt {
    font-weight: 350;
    font-size: 16px;
    color: #000000;
    line-height: 28px;
  }
}

#section2 {
  .content {
    position: relative;
    margin-top: 57px;
    // margin-right: 27px;
    .th {
      font-weight: 300;
      font-size: 64px;
      color: #1485ef;
      line-height: 112px;
    }
    .th2 {
      width: 34px;
      height: 80px;
      font-family: Pro;
      font-weight: 900;
      font-size: 64px;
      color: #1485ef;
      line-height: 80px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .txt {
      margin-left: 8px;
      font-weight: 350;
      font-size: 14px;
      color: #9e9e9e;
      line-height: 21px;
    }
    .th4 {
      margin-top: 19px;
      margin-bottom: 10px;
      font-weight: 400;
      font-size: 16px;
      color: #9e9e9e;
      line-height: 23px;
    }
  }
  .pic {
    position: relative;
    top: 70px;
    left: 27px;
    height: 100%;
  }
}
#section3 {
  .list {
    margin-top: 49px;
    margin-bottom: 80px;
    .item {
      width: 25%;
      .icon {
        font-size: 46px;
      }
      .th2 {
        margin-top: 11px;
        font-weight: 700;
        font-size: 18px;
        color: #000000;
        line-height: 22px;
      }
      .tips {
        margin-top: 15px;
        width: 190px;
        font-weight: 350;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 21px;
      }
    }
  }
}

#section4 {
  height: 600px;
  background: #f4f4f4;
  overflow: hidden;
  .th {
    margin-top: 49px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 112px;
  }
  .box {
    position: relative;
    margin-top: 49px;
    margin-bottom: 80px;
    img {
      position: absolute;
      top: -120px;
      left: 222px;
      width: 494px;
      height: 494px;
    }
    .item {
      position: absolute;
      .th2 {
        font-weight: 700;
        font-size: 24px;
        color: #000000;
        line-height: 42px;
      }
      .tips {
        width: 283px;
        font-weight: 350;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 21px;
      }
      &.t1 {
        top: 0;
        left: 0;
        text-align: right;
      }
      &.t2 {
        top: -18px;
        left: 625px;
      }
      &.t3 {
        top: 228px;
        left: -46px;
        text-align: right;
      }
      &.t4 {
        top: 204px;
        left: 670px;
      }
    }
  }
}

#section5 {
  padding: 60px 0;
  .th2 {
    width: 576px;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 83px;
  }
  .tips {
    margin-top: 20px;
    width: 573px;
    font-weight: 350;
    font-size: 14px;
    color: #9e9e9e;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/acq.vue